module.exports = __webpack_public_path__ + "img/1-5.697f7615.svg";